import React from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { Box, Divider } from '@stitch-fix/mode-react';
import { useProductDetailsPageContext } from '../ProductDetailsPage/ProductDetailsPageContext/ProductDetailsPageContext';
import { useSizeGuideContext } from './SizeGuideContext/SizeGuideContext';
import SizeChart from './SizeChart';
import SizeComparison from './SizeComparison';
import HowToMeasure from './HowToMeasure';
import styles from './styles.module.scss';

const SizeGuide = () => {
  const [desktopState] = useProductDetailsPageContext();
  const [mobileState] = useSizeGuideContext();
  const businessLine =
    desktopState?.productBusinessLine?.toUpperCase() ||
    mobileState?.productBusinessLine?.toUpperCase();

  if (!businessLine) {
    return null;
  }

  return (
    <Tabs>
      <TabList className={styles['size-guide-tabs-list']}>
        <Tab
          className={styles['size-guide-tab-header']}
          selectedClassName={styles['size-guide-tab-header-selected']}
        >
          Size chart
        </Tab>
        {businessLine === 'MENS' && (
          <Tab
            className={styles['size-guide-tab-header']}
            selectedClassName={styles['size-guide-tab-header-selected']}
          >
            Size comparison
          </Tab>
        )}
        <Tab
          className={styles['size-guide-tab-header']}
          selectedClassName={styles['size-guide-tab-header-selected']}
        >
          How to measure
        </Tab>
      </TabList>

      <Box styleName="full-width">
        <Divider variant="subtle" mb={1.5} />
      </Box>

      <TabPanel
        className={styles['size-guide-tab-panel']}
        selectedClassName={styles['size-guide-tab-panel-selected']}
      >
        <SizeChart businessLine={businessLine} />
      </TabPanel>

      {businessLine === 'MENS' && (
        <TabPanel
          className={styles['size-guide-tab-panel']}
          selectedClassName={styles['size-guide-tab-panel-selected']}
        >
          <SizeComparison />
        </TabPanel>
      )}

      <TabPanel
        className={styles['size-guide-tab-panel']}
        selectedClassName={styles['size-guide-tab-panel-selected']}
      >
        <HowToMeasure businessLine={businessLine} />
      </TabPanel>
    </Tabs>
  );
};

export default SizeGuide;
